﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            sessionId: String,
            sendCodeUrl: String
        }
    }

    static get targets() {
        return ["resendCode", "countdown", "successMessage", "failedMessage"];
    }

    connect() {
        const verificationStateJson = localStorage.getItem("verificationState");
        let verificationState;

        if (!verificationStateJson || (verificationState = JSON.parse(verificationStateJson)).sessionId !== this.sessionIdValue) {
            void this.sendCode();
            return;
        }

        verificationState.lastRequested = new Date(verificationState.lastRequested);
        this.restoreVerificationState(verificationState);
    }

    resendCode(e) {
        e.preventDefault();
        this.resendCodeTarget.disabled = true;
        void this.sendCode();
    }

    enableResendCodeAfterCountdown(countdown) {
        if (countdown > 0) {
            this.countdownTarget.textContent = `(${countdown})`;
            const interval = setInterval(
                () => {
                    countdown--;
                    this.countdownTarget.textContent = `(${countdown})`;

                    if (countdown > 0) {
                        return;
                    }

                    this.resendCodeTarget.disabled = false;
                    this.countdownTarget.textContent = "";
                    clearInterval(interval);
                },
                1000
            );
        } else {
            this.resendCodeTarget.disabled = false;
        }
    }

    restoreVerificationState({ lastRequested, successfullySentCode, secondsToWait }) {
        this.successMessageTarget.classList.toggle("d-none", !successfullySentCode);
        this.failedMessageTarget.classList.toggle("d-none", successfullySentCode);
        const canRequestAfter = new Date(lastRequested.getTime() + (secondsToWait * 1000));
        this.enableResendCodeAfterCountdown(Math.max(0, Math.ceil((canRequestAfter.getTime() - Date.now()) / 1000)));
    }

    async sendCode() {
        this.successMessageTarget.classList.add("d-none");
        this.failedMessageTarget.classList.add("d-none");
        const response = await fetch(this.sendCodeUrlValue, { method: "post" });
        const { successfullySentCode, secondsToWait } = await response.json();
        const verificationState = {
            sessionId: this.sessionIdValue,
            lastRequested: new Date(),
            successfullySentCode,
            secondsToWait
        };
        localStorage.setItem("verificationState", JSON.stringify(verificationState));
        this.restoreVerificationState(verificationState);
    }
}